import { useMemo } from 'react';

const norm = (s: string) =>
    s
        ?.normalize?.('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase() ?? '';

/** Same ordering as AreaList.state (_areas / _areaGroups): interleave areas and groups by sortNumber. */
const compareBySortNumberThenName = (a: any, b: any): number => {
    const an = a.attributes?.sortNumber ?? Infinity;
    const bn = b.attributes?.sortNumber ?? Infinity;
    if (an !== bn) return an - bn;
    return (a.attributes?.displayName ?? '').toLowerCase().localeCompare((b.attributes?.displayName ?? '').toLowerCase());
};

/** Merges areas + area groups in sort order and filters by search; must be called from a React component. */
export function useFilterAreasAndAreaGroups(areas: any[], areaGroups: any[], searchInput: string): any[] {
    const combined = useMemo(() => [...areas, ...areaGroups].sort(compareBySortNumberThenName), [areas, areaGroups]);

    const filteredResult = useMemo(() => {
        const searchQuery = norm((searchInput || '').trim());
        if (!searchQuery) return combined;

        const filteredValues = combined.filter((item: any) => {
            const attributes = item?.attributes || {};
            if (attributes.displayName && norm(attributes.displayName).includes(searchQuery)) return true;
            if (attributes.areaLabel && norm(attributes.areaLabel).includes(searchQuery)) return true;
            if (attributes.areaGroupLabel && norm(attributes.areaGroupLabel).includes(searchQuery)) return true;
            return false;
        });

        return filteredValues;
    }, [combined, searchInput]);

    return filteredResult;
}
